/*
 * This file is part of the Norges Musikkhøyskole Nettsted 2020 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormOverlay from './FormOverlay/FormOverlay';

import styles from './ModalForm.module.scss';

/**
 * This is the ModalForm component.
 *
 * @author Anders Stalheim Øfsdahl <anders@apt.no>
 *
 * @return {JSX}
 */
function ModalForm({ className, encodedForm, labels, heading, body }) {
  const [showForm, setShowForm] = useState(false);

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <button
        className={classNames(styles.main, className)}
        onClick={() => {
          setShowForm(true);
        }}
      >
        {labels.button}
      </button>
      <FormOverlay
        visible={showForm}
        encodedForm={encodedForm}
        heading={heading}
        body={body}
        onClose={handleClose}
        labels={labels}
      />
    </>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ModalForm.propTypes = {
  encodedForm: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.string,
  labels: PropTypes.shape({
    button: PropTypes.string,
    success: PropTypes.string,
    error: PropTypes.string,
  }),
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
ModalForm.defaultProps = {
  encodedForm: null,
  heading: null,
  body: null,
  labels: {
    button: 'Click me',
    success: 'Yay!',
    error: 'Nay!',
  },
};

export default ModalForm;
